import type { SxProps, Theme } from '@portals/core/src/themes/themes';

export const getStyles = (theme: Theme, size?: 'default' | 'small'): { [key: string]: SxProps } => ({
  button: {
    color: 'inherit',
    borderRadius: '50%',
    fontSize:
      size === 'small'
        ? { xs: theme.spacing(5), lg: theme.spacing(6) }
        : { xs: theme.spacing(6), lg: theme.spacing(8) },
    '&.MuiIconButton-root': {
      padding: size === 'small' ? { xs: theme.spacing(4), lg: '15px' } : { xs: 3 },
    },
    '&:focus, &:focus-visible, &.Mui-focused': {
      outline: `2px solid ${theme.palette.action.focus}`,
      borderColor: 'transparent',
      color: 'inherit',
    },
  },
});
